/**
 * Migration Modal — Shows progress during a migration of the open map: its
 * notes to Y.XmlFragment (default texts), or its format to schema v2
 * (engine/sync/map-format-migration.js passes its own texts).
 * Blocks interaction, shows progress bar, prevents tab close.
 */

import { t } from '../../../shared/i18n/index.js';
import { escapeHtml } from '../../../engine/core/validation.js';

let modalEl = null;
let progressBar = null;
let progressText = null;
let beforeUnloadHandler = null;
let texts = {};

/**
 * Show the migration modal.
 * @param {{title?: string, intro?: string, preparing?: string, done?: string, failed?: string}} [custom]
 *   texts in place of the notes migration's
 */
export function showMigrationModal(custom = {}) {
  if (modalEl) return;
  texts = custom;

  modalEl = document.createElement('div');
  modalEl.className = 'migration-modal-overlay';
  modalEl.innerHTML = `
    <div class="migration-modal">
      <h3>${escapeHtml(texts.title || t('account.migration.title'))}</h3>
      <p>${escapeHtml(texts.intro || t('account.migration.intro'))}<br>${escapeHtml(t('account.migration.wait'))}</p>
      <div class="migration-progress-bar">
        <div class="migration-progress-fill"></div>
      </div>
      <div class="migration-progress-text">${escapeHtml(texts.preparing || t('account.migration.preparing'))}</div>
    </div>
  `;

  document.body.appendChild(modalEl);
  progressBar = modalEl.querySelector('.migration-progress-fill');
  progressText = modalEl.querySelector('.migration-progress-text');

  // Prevent tab close during migration
  beforeUnloadHandler = (e) => {
    e.preventDefault();
    e.returnValue = t('account.migration.leaveWarning');
    return e.returnValue;
  };
  window.addEventListener('beforeunload', beforeUnloadHandler);
}

/**
 * Update migration progress.
 * @param {number} current - Current item
 * @param {number} total - Total items
 */
export function updateMigrationProgress(current, total) {
  if (!progressBar || !progressText) return;
  const pct = total > 0 ? Math.round((current / total) * 100) : 0;
  progressBar.style.width = `${pct}%`;
  progressText.textContent = t('account.migration.progress', { current, total });
}

/**
 * Hide the migration modal.
 * @param {boolean} [success=true] - Whether migration succeeded
 */
export function hideMigrationModal(success = true) {
  if (beforeUnloadHandler) {
    window.removeEventListener('beforeunload', beforeUnloadHandler);
    beforeUnloadHandler = null;
  }

  if (modalEl) {
    if (success) {
      progressText.textContent = texts.done || t('account.migration.done');
      progressBar.style.width = '100%';
      setTimeout(() => {
        modalEl?.remove();
        modalEl = null;
        progressBar = null;
        progressText = null;
      }, 800);
    } else {
      progressText.textContent = texts.failed || t('account.migration.failed');
      progressBar.style.background = '#e53e3e';
      setTimeout(() => {
        modalEl?.remove();
        modalEl = null;
        progressBar = null;
        progressText = null;
      }, 2000);
    }
  }
}
